export const environment = {
  production: false,
    // url_point:'https://x753test-clientportalapi.cx360.net',
    // url_point : 'https://qaportalapi.cx360.net',
    url_point : 'http://localhost:5185',
    // url_point :'https://ccoportalapi.cx360.net'
    

    
  };